export const MEMBER_COMPLIANCE_STATUS_OPTIONS = [
  { key: 'valid', value: 'valid', text: 'Valid' },
  { key: 'expired', value: 'expired', text: 'Expired' },
  { key: 'not_required', value: 'not_required', text: 'Not Required' },
  { key: 'pending', value: 'pending', text: 'Pending' },
  { key: 'unknown', value: 'unknown', text: 'Unknown' },
];

export const MEMBER_PCARD_STATUS_OPTIONS = [
  { key: 'active', value: 'active', text: 'Active' },
  { key: 'inactive', value: 'inactive', text: 'Inactive' },
  { key: 'not_issued', value: 'not_issued', text: 'Not Issued' },
  { key: 'pending', value: 'pending', text: 'Pending' },
  { key: 'unknown', value: 'unknown', text: 'Unknown' },
];

/** TDS-provided IT device types (ITFIBERCON-386); separate from construction assets. */
export const MEMBER_DEVICE_TYPE_OPTIONS = [
  { key: 'cell_phone', value: 'cell_phone', text: 'Cell Phone' },
  { key: 'laptop', value: 'laptop', text: 'Laptop' },
  { key: 'ipad', value: 'ipad', text: 'iPad' },
  { key: 'tablet', value: 'tablet', text: 'Tablet' },
];

export const formatComplianceStatus = (value) => {
  const option = MEMBER_COMPLIANCE_STATUS_OPTIONS.find((o) => o.value === value);
  return option ? option.text : value || 'Unknown';
};

export const formatDeviceType = (value) => {
  const option = MEMBER_DEVICE_TYPE_OPTIONS.find((o) => o.value === value);
  return option ? option.text : value;
};

export const formatAssignedDeviceTypes = (codes) => {
  if (!codes || codes.length === 0) {
    return '—';
  }
  return codes.map(formatDeviceType).join(', ');
};
